import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

export type SubjectMemberAccess = 'full' | 'read_only';

/** Adds a member or changes the access of an existing one. */
class PutSubjectMember {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly userId: number,
		public readonly access: SubjectMemberAccess,
	) {
		Object.freeze(this);
	}

	toJSON(): { access: SubjectMemberAccess } {
		return { access: this.access };
	}
}

export default PutSubjectMember;
